import React from "react";
import { connect } from "react-redux";
import { updateRouteOn3dSwitch } from "../../MapStore2/web/client/epics/globeswitcher";
import { registerPlugin } from "../common/mapstore/registerPlugin";
import { globeViewEpic } from "./redux/globe/globeView.epic";
import { hideWmsLayersEpic } from "./redux/globe/hideWmsLayers.epic";
import { disableResolutionLimitsEpic } from "./redux/globe/disableResolutionLimits.epic";
import { wms3dLayersReducer } from "./redux/wms3dLayers.reducer";

class GlobeView extends React.Component {
    static propTypes = {};

    render() {
        return null;
    }
}

export const ConnectedGlobeView = connect(() => {
    return {};
}, {})(GlobeView);

export const GlobeViewPlugin = {
    name: "GlobeViewPlugin",
    config: {
        component: ConnectedGlobeView,
        reducers: {
            wms3dLayers: wms3dLayersReducer,
        },
        epics: {
            globeViewEpic,
            updateRouteOn3dSwitch,
            hideWmsLayersEpic,
            disableResolutionLimitsEpic,
        },
    },
};
export const register = () => registerPlugin(GlobeViewPlugin);
